import { INFO, TOAST_MESSAGE_DURATION } from 'constants/error-severities';

import {
  HIDE_CONFIRMATION_MODAL,
  SHOW_CONFIRMATION_MODAL,
  UPDATE_CONFIRMATION_MODAL_MESSAGE,
} from '../constants/actions';

export const hideConfirmationModal = () => {
  return { type: HIDE_CONFIRMATION_MODAL };
};

export const showConfirmationModal = (
  message,
  severity = INFO,
  timerTimeout = TOAST_MESSAGE_DURATION
) => {
  return {
    type: SHOW_CONFIRMATION_MODAL,
    message,
    severity,
    timerTimeout,
  };
};

export const updateConfirmationModalMessage = message => {
  return {
    type: UPDATE_CONFIRMATION_MODAL_MESSAGE,
    message,
  };
};
